import { Monitor, Moon, Sun } from 'lucide-react';
import { useThemeStore, type ThemePreference } from '@/stores/theme.store';
import { Button, type ButtonSize } from '@/components/ui/Button';
import { Tooltip } from '@/components/ui/Tooltip';

const ICONS: Record<ThemePreference, typeof Sun> = {
  dark: Moon,
  light: Sun,
  system: Monitor,
};

const LABELS: Record<ThemePreference, string> = {
  dark: 'Dark theme',
  light: 'Light theme',
  system: 'System theme',
};

export function ThemeToggle({ size = 'icon' }: { size?: ButtonSize }) {
  const preference = useThemeStore((state) => state.preference);
  const cycle = useThemeStore((state) => state.cycle);
  const Icon = ICONS[preference];

  return (
    <Tooltip content={`${LABELS[preference]} - click to change`}>
      <Button
        variant="ghost"
        size={size}
        onClick={cycle}
        aria-label={`Theme: ${LABELS[preference]}. Change theme.`}
      >
        <Icon className={size === 'icon-sm' ? 'h-3.5 w-3.5' : 'h-4 w-4'} />
      </Button>
    </Tooltip>
  );
}
